export default __webpack_public_path__ + "static/media/operon_big.31e00074.png";